/**
* Created by kongwm.kong on 2017/7/26.
*/
<template>
    <div>
        <!--<modal name="changeMobile-step1" :width="393">-->
            <!--<div class="vue-modal-wrap changeMobile1">-->
                <!--<div class="modal-title">更改手机号码<span @click="hideMobile">x</span></div>-->
                <!--<div class="modal-bd">-->
                    <!--<form @submit.prevent="validatePass">-->
                        <!--<div class="input-wrap">-->
                            <!--<input type="password" v-validate="'required|password'" v-model="userPass"  placeholder="请输入您的密码" name="password" >-->
                            <!--<div class="err">-->
                                <!--<span v-show="errors.has('password')">{{errors.first('password')}}</span>-->
                            <!--</div>-->
                        <!--</div>-->
                        <!--<button class="btn-bg-def btn" type="submit">下一步</button>-->
                    <!--</form>-->
                <!--</div>-->
            <!--</div>-->
        <!--</modal>-->
        <modal name="changeMobile-step1" :width="393">
            <div class="vue-modal-wrap changeMobile2">
                <div class="modal-title">更改手机号码<span @click="hideMobile2">x</span></div>
                <div class="modal-bd">
                    <div class="err-wrap clearfix">
                        <div class="err err1">{{msgErr}}</div>
                    </div>
                    <form @submit.prevent="validateMobile">
                        <div class="input-wrap">
                            <input type="password" v-validate="'required|password'" v-model="userPass"  placeholder="请输入您的密码" name="password" >
                            <div class="err">
                                <span v-show="errors.has('password')">{{errors.first('password')}}</span>
                            </div>
                        </div>
                        <div class="input-wrap">
                            <input type="text" v-validate="'required'" v-model="imageCode"  placeholder="请输入图形验证码" name="validImg" >
                            <div class="send-code-wrap" @click="getImgCode"><img :src="imgSrc" width="110" height="40"></div>
                            <div class="err">
                                <span v-show="errors.has('validImg')">{{errors.first('validImg')}}</span>
                            </div>
                        </div>
                        <div class="input-wrap">
                            <input type="text" v-validate="'required|mobile'" v-model="userMobile" placeholder="请输入新的手机号码" name="mobile" >
                            <div class="err">
                                <span v-show="errors.has('mobile')">{{errors.first('mobile')}}</span>
                            </div>
                        </div>
                        <div class="input-wrap valid-mobile">
                            <input type="text" placeholder="请输入手机验证码" v-validate="'required|number'" v-model="validCode" name="validCode" >
                            <!--<div class="send-code-wrap"><send-code :phone="userMobile"  @changeImgCode="getImgCode" :imageCode="imageCode" :validPhone="validPhone" @changeErrTipFlag="changeErrTipFlag" @changeTipFlag="changeFlag"></send-code></div>-->
                            <div class="err">
                                <span v-show="errors.has('validCode')">{{errors.first('validCode')}}</span>
                            </div>
                        </div>
                        <div class="send-tip" v-show="sendTipFlag ">
                            <div class="radius-icon"></div>
                            校验码已发送至您的手机，请查收
                        </div>
                        <div class="err-wrap clearfix">
                            <div class="err" v-show="errTipFlag">{{errTipMsg}}</div>
                        </div>
                        <button class="btn-bg-def btn"   type="submit">确定</button>

                    </form>
                    <div class='img_valid_wrap code_valid_wrap'>
                        <div class="img_valid"><button :class="['send-code', {'disabled':disabled}]" id="sendCode" @click="sendCode">发送验证码</button></div>
                    </div>
                </div>
            </div>
        </modal>

    </div>
</template>
<script>
//    import sendCode from '../../components/common/sendCode'
    import CountDown from  '../../assets/js/common/countdown';
    export default {
        components: {
//            sendCode
        },
        data(){
            return {
                msgErr: '',
                imageCode: '',
                userPass: null,
                userMobile:null,
                validCode: null,
                sendTipFlag: false,
                errTipMsg: '',
                errTipFlag : false,
                imgSrc: '/v1/security-code/image',
            }
        },
        computed:{
            validPhone(){
                return this.errors.has('mobile');
            }
        },
        mounted(){
            this.getImgCode();
        },
        methods : {
            sendCode(e){
                e.preventDefault();
                this.authCode =  new CountDown({
                    id: 'sendCode',
                    disabledClass: 'send-code disabled',
                    normalClass:'send-code ',
                    clickFont: '秒后重新发送',
                    afterFont: '发送验证码',
                    path: '/',
                    pathFlag: '11'
                });
                let imgCode = $("input[name='validImg']").val();
                if(!(this.errors.has('mobile'))&& this.userMobile && imgCode){
                    let url = `/security-code/${this.userMobile}/sendPhoneSecurityCode?imageCode=${imgCode}`;
                    this.$http.request({
                        url: url
                    }, response=>{
                        if(response.data.code===401){
                            let obj = {
                                flag: true,
                                msg: response.data.message
                            };
                            this.changeErrTipFlag(obj);  //出错后的提示
                            this.getImgCode();
                        } else if(response.data.code == 200){
                            this.authCode.startCount();
                            this.changeErrTipFlag({flag: false, msg: ''});
                        } else{
                            this.getImgCode();
                        }
                    }, err=>{
                        this.getImgCode();
                    });
                } else {
                    this.changeErrTipFlag({flag: true, msg: '请输入正确手机号码、验证码'});
                }

            },
            getImgCode(){
                this.imgSrc = '/v1/security-code/image?'+ Math.random();
                this.imageCode = '';
            },
            showMobile(){
                this.$modal.show('changeMobile-step1');
            },
            hideMobile(){
                this.$modal.hide('changeMobile-step1');
            },
            hideMobile2(){
                this.$modal.hide('changeMobile-step1');
            },
            showMobile2(){
                this.getImgCode();
                this.$modal.show('changeMobile-step2');
            },
            validatePass(e){
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.hideMobile();
                        this.userPass = null;
                        this.showMobile2();
                        return false;
                    }
                });
            },
            validateMobile(){
                this.$validator.validateAll().then(result => {
                    if (result) {
                        this.$http.request({
                            url: `/account/changeBindPhone`,
                            method: 'put',
                            data:{
                                phone: this.userMobile,
                                code: this.validCode,
                                password: this.userPass
                            }
                        }, response => {
                            if(response.data.code === 200){
                                this.$emit('listenChangeMobile',this.userMobile);
                                this.validCode = null;
                                this.userMobile = null;
                                this.hideMobile2();
                                this.$store.commit('msg','修改成功');
                                this.msgErr = '';

                            } else if(response.data.code === 401){
                                this.msgErr = response.data.message;
                            }
                        }, err => {
                            this.msgErr = '服务器繁忙';
                        });
                        return false;
                    }
                });
            },
            changeFlag(flag){
                this.sendTipFlag = flag;
            },
            changeErrTipFlag(obj){
                this.errTipFlag = obj.flag;
                this.errTipMsg = obj.msg;
            }
        }
    }
</script>
<style lang="scss" type="text/scss" scoped>
    .vue-modal-wrap{
        .send-code{
            position: absolute;
            right:34px;
            top: 271px;
            width: 110px;
            height:38px;
            background: $c_f5f;
            font-size: 14px;
            color: $btn_408;
            &.disabled{
                color:$c_989;
            }
        }
        .btn{
            margin: 100px auto 0;
            display: block;
            width:204px;
            height:50px;
            background: $btn_408;
            color:#fff;
            font-size:18px;
            font-weight: bold;
            text-align: center;
            cursor: pointer;
            line-height: 50px;
        }
        .err-wrap{
            position: relative;
            .err{
                top:20px;
            }
            .err1{
                top:0;
            }
        }
        .err{
            font-size: 14px;
            position: absolute;
            top:44px;
            left:0;
            width:100%;
        }
    }

    .vue-modal-wrap.changeMobile1{
        width: 393px;
        .modal-bd{
            padding: 40px 33px;
            .input-wrap{
                position:relative;
            }
            input{
                width:100%;
                height:40px;
                border: 1px solid $border_bfb;
                padding: 10px 0;
                line-height: 1;
                font-size: 18px;
                color: $c_666;
                text-indent: 20px;
            }
        }
    }

    .vue-modal-wrap.changeMobile2{
        width: 393px;
        .modal-bd{
            padding: 40px 33px;
            .input-wrap{
                height:40px;
                border: 1px solid $border_bfb;
                font-size: 18px;
                color: $c_666;
                position:relative;
                &+.input-wrap{
                    margin-top:20px;
                }
                input{
                    width:100%;
                    height: 38px;
                    padding: 8px 0;
                    line-height: 1;
                    text-indent: 20px;
                }
                .send-code-wrap{
                    position: absolute;
                    top:0;
                    height:38px;
                    width:120px;
                    right:0;
                    background: $c_f5f;
                    line-height: 38px;
                    text-align:center;
                    img{
                        position: absolute;
                        top:0;
                        left:0;
                        width:100%;
                        height: 100%;
                    }
                }
                .err{
                    top:38px;
                }
            }
            /*提示*/
            .send-tip{
                margin-top:14px;
                color:$c_b7b;
                font-size: 14px;
                letter-spacing: -0.34px;
                .radius-icon{
                    display: inline-block;
                    vertical-align: middle;
                    width:14px;
                    height:14px;
                    border-radius: 50%;
                    background: #d8d8d8;
                }
            }
            .btn{
                margin-top:40px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/modal/changeMobile.vue